import * as $$String from "bs-platform/lib/es6/string.js";
import * as Caml_string from "bs-platform/lib/es6/caml_string.js";

function unwrap(x) {
  return $$String.make(1, x);
}

function wrap(x) {
  return Caml_string.get(x, 0);
}

export { unwrap, wrap };
/* No side effect */